export enum PreQualificationStep {
  LoanAmount = 'LoanAmount',
  LoanInformation = 'LoanInformation',
  TermsOfUse = 'TermsOfUse',
  BorrowerPhoneVerification = 'BorrowerPhoneVerification',
  CoBorrowerPhoneVerification = 'CoBorrowerPhoneVerification',
  VerificationComplete = 'VerificationComplete',
  BorrowerInfo = 'BorrowerInfo',
  CoBorrowerInfo = 'CoBorrowerInfo',
  BorrowerIncome = 'BorrowerIncome',
  CoBorrowerIncome = 'CoBorrowerIncome',
  Contractor = 'Contractor',
  SignIn = 'SignIn',
  CreateAccount = 'CreateAccount',
  AlreadyHaveActiveApplication = 'AlreadyHaveActiveApplication',
  BorrowerAsCoBorrowerAlreadyHaveActiveApplication = 'BorrowerAsCoborrowerAlreadyHaveActiveApplication',
  CoBorrowerAlreadyHaveActiveApplication = 'CoBorrowerAlreadyHaveActiveApplication',
  NotAbleToAccept = 'NotAbleToAccept',
  UnfreezeCredit = 'UnfreezeCredit',
  NoOptions = 'NoOptions',
  Decline = 'Decline',
  RedirectToProveLink = 'RedirectToProveLink',
  NotFoundContact = 'NotFoundContact',
}
